import { render, staticRenderFns } from "./WaterResources.vue?vue&type=template&id=56b03529"
import script from "./WaterResources.vue?vue&type=script&lang=js"
export * from "./WaterResources.vue?vue&type=script&lang=js"
import style0 from "./WaterResources.vue?vue&type=style&index=0&id=56b03529&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports